<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import useConfig from '../../../../Composables/useConfig'
import useUser from '../../../../Composables/User/useUser.ts'

const props = defineProps({
  contract: { type: Object, required: true },
  def: { type: Object, required: true },
})

const { t, n } = useI18n()
const { hasFeature } = useConfig()
const { hasRole } = useUser()

const commissionAvailable = computed(() => {
  return (
    props.contract.finance &&
    hasFeature('commissions') &&
    props.contract.finance.commissionAmount &&
    !hasRole('ROLE_PROFITABILITY_SHOW')
  )
})

const computeEquipmentAmount = computed(() => {
  let amount = 0
  if (props.contract?.finance) {
    amount = parseFloat(props.contract.finance.amount)
    if (props.contract.finance.outstanding !== null && props.contract.finance.computeType === 'RENT') {
      amount -= parseFloat(props.contract.finance.outstanding)
    }
  }
  return n(Number(amount), 'currency')
})
</script>

<template>
  <div>
    <div class="row mb-3">
      <div class="col">
        {{ def.equipment.equipmentType?.label ?? t('contract.fields.equipmentType.label') }}
      </div>
      <div class="col" e2e-data="contractEquipmentTypeName">
        {{ contract.finance.equipment.equipmentType ? contract.finance.equipment.equipmentType.name : '' }}
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        {{ t('contract.fields.productType.label') }}
      </div>
      <div class="col" e2e-data="contract" ProductTypeName>
        {{ contract.finance.equipment.productType ? contract.finance.equipment.productType.name : '' }}
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        {{ def.equipment.condition?.label ?? t('contract.fields.condition.label') }}
      </div>
      <div class="col" e2e-data="contractEquipmentCondition">
        {{ t('equipmentCondition.choices.' + contract.finance.equipment.condition + '.label') }}
      </div>
    </div>
    <div class="row mb-3" v-if="contract.finance.equipment && contract.finance.equipment.year">
      <div class="col">
        {{ t('simulation.fields.year.label') }}
      </div>
      <div class="col" e2e-data="contractEquipmentYear">
        {{ contract.finance.equipment.year }}
      </div>
    </div>
    <div class="row mb-3" v-if="commissionAvailable">
      <div class="col">
        {{ t('contract.fields.commission.label') }}
      </div>
      <div class="col" e2e-data="contractCommissionAmount">
        {{ n(Number(contract.finance.commissionAmount), 'currency') }}
      </div>
    </div>
    <div class="row mb-3" v-if="contract.finance.outstanding">
      <div class="col">
        {{ t('contract.fields.finance.outstanding.label') }}
      </div>
      <div class="col" e2e-data="contractOutstanding">
        {{ n(Number(contract.finance.outstanding), 'currency') }}
      </div>
    </div>
    <div class="row mb-3" v-if="contract.finance.outstanding && contract.finance.computeType === 'RENT'">
      <div class="col">
        {{ t('contract.fields.equipmentAmount.label') }}
      </div>
      <div class="col" e2e-data="contractEquipmentAmount">
        {{ computeEquipmentAmount }}
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        {{ def.finance.fullAmount?.label ?? t('contract.fields.amount.label') }}
      </div>
      <div class="col" e2e-data="contractAmount">
        {{ n(Number(contract.finance.amount), 'currency') }}
      </div>
    </div>
  </div>
</template>
